import React from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import Collapse from '@material-ui/core/Collapse'
import Divider from '@material-ui/core/Divider'
import Icon from '@material-ui/core/Icon'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import MenuItem from '@material-ui/core/MenuItem'

import classNames from 'classnames'

import Link from 'react-router-dom/Link'

import Constant from './../../../shared/utils/Contants'
import Colors from '../../../shared/assets/styles/colors'

const styles = theme => ({
  root: {
    display: 'flex',
    width: 320
  },
  list: {
    backgroundColor: Colors.White,
    borderRight: `1px solid rgba(0, 0, 0, 0.12)`,
    flexDirection: 'column',
    width: '100%',
    overflowY: 'scroll'
  },
  menuItemRoot: {
    paddingLeft: 0
  },
  menuItemSelected: {
    '&::before': {
      content: '""',
      border: `0 solid ${Colors.Brand}`,
      borderLeftWidth: '2px !important',
      position: 'absolute',
      height: '100%'
    }
  },
  menuIconSelected: {
    color: Colors.Brand
  },
  menuLabel: {
    paddingLeft: 0,
    paddingRight: 0,
    '&:first-child': {
      paddingLeft: 72
    }
  },
  menuText: {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'normal'
    // width: 150
  },
  toolbar: theme.mixins.toolbar,
  drawerPaper: {
    position: 'relative',
    height: 'auto',
    width: Constant.drawerWidth
  },
  expandIcon: {
    color: theme.palette.action.active
  }
})

class Menu extends React.Component {
  constructor(props) {
    super(props)

    const activeMenuItem = this.props.menu.find(menuItem => {
      return menuItem.items.find(item =>
        window.location.pathname.startsWith(item.to)
      )
    })

    this.state = {}
    if (activeMenuItem) {
      this.state[activeMenuItem.label] = true
    }

    this.renderMenuItem = this.renderMenuItem.bind(this)
  }

  static defaultProps() {
    return {
      menu: []
    }
  }

  renderMenuItem(menuItem, k) {
    const {classes} = this.props
    let isMenuActive = false

    const createSubMenu = menuItem => {
      if (menuItem.items) {
        return menuItem.items.map((item, k) => {
          let isActive = window.location.pathname.startsWith(item.to)
          isMenuActive = isMenuActive || isActive

          return (
            <Collapse
              in={this.state[menuItem.label]}
              key={k}
              timeout="auto"
              unmountOnExit
            >
              <MenuItem
                component={Link}
                to={item.to}
                button
                selected={isActive}
                classes={{
                  root: classes.menuItemRoot,
                  selected: classes.menuItemSelected
                }}
              >
                <ListItemText
                  inset
                  primary={item.label}
                  className={classes.menuLabel}
                  primaryTypographyProps={{
                    className: classes.menuText
                  }}
                />
              </MenuItem>
            </Collapse>
          )
        })
      }
    }

    const subMenu = createSubMenu(menuItem)

    return (
      <React.Fragment key={k}>
        <ListItem button onClick={this.handleClick.bind(this, menuItem.label)}>
          <ListItemIcon>
            <Icon
              className={classNames({[classes.menuIconSelected]: isMenuActive})}
            >
              {menuItem.icon}
            </Icon>
          </ListItemIcon>
          <ListItemText
            inset
            primary={menuItem.label}
            className={classes.menuLabel}
            primaryTypographyProps={{className: classes.menuText}}
          />

          {menuItem.items && (
            <Icon className={classes.expandIcon}>
              {this.state[menuItem.label] ? 'expand_less' : 'expand_more'}{' '}
            </Icon>
          )}
        </ListItem>

        {subMenu}

        <Divider />
      </React.Fragment>
    )
  }

  handleClick(item) {
    this.setState({[item]: !this.state[item]})
  }

  render() {
    const {classes} = this.props

    return (
      <div className={classes.root}>
        <List disablePadding className={classes.list}>
          {this.props.menu.map(this.renderMenuItem)}
        </List>
      </div>
    )
  }
}

export default withStyles(styles)(Menu)



// WEBPACK FOOTER //
// ./src/components/molecules/Menu/Menu.js